{
	"pleaseSelectAFolder": "Please Select a Folder",
	"selectAFolderInstead": "Select a folder instead",
	"selectingFilesIsNotSupported": "Selecting files is not supported",
	"yourImportFailedBecauseThe": "Your import failed because the selected file is not in a folder. Select or drop a folder that contains your file(s) instead."
}
